import TenantSelector from './tenantSelector';

export default TenantSelector;
